<template>
    <li class="relative">
        <div class="pb-6 pl-10">
            <component
                :is="is"
                :entry="entry"
                :job-sheet="jobSheet"
            />

            <files-lists
                :files="entry.files.data"
                :show-empty="false"
                class="mt-4"
            />
        </div>

        <div
            class="absolute border-2 border-l rounded"
            :style="{
                top: '32px',
                left: '10px',
                bottom: '6px'
            }"
        />
    </li>
</template>

<script>
    import FilesLists from './files-list'
    import JobSheetEntriesListItemComment from './job-sheet-entries-list-item-comment'
    import JobSheetEntriesListItemContactLandlord from './job-sheet-entries-list-item-contact-landlord'
    import JobSheetEntriesListItemUndefined from './job-sheet-entries-list-item-undefined'

    export default {
        components: {
            FilesLists,
            JobSheetEntriesListItemComment,
            JobSheetEntriesListItemContactLandlord,
            JobSheetEntriesListItemUndefined
        },
        props: {
            jobSheet: {
                type: Object,
                required: true
            },
            entry: {
                type: Object,
                required: true
            }
        },
        computed: {
            is () {
                switch (this.entry.type) {
                    case 'comment':
                        return 'job-sheet-entries-list-item-comment'
                    case 'contact_landlord':
                        return 'job-sheet-entries-list-item-contact-landlord'
                    default:
                        return 'job-sheet-entries-list-item-undefined'
                }
            },
            title () {
                switch (this.entry.type) {
                    case 'job_sheet_created':
                        return this.entry.first_name + ' shared this job sheet with you.'
                    case 'landlord_contact_details':
                        return this._.possession(this.entry.first_name) + ' contact details.'
                    case 'comment':
                        return (this.entry.first_name || 'You') + ' left a comment.'
                    default:
                        return this.entry.type
                }
            },
            icon () {
                switch (this.entry.type) {
                    case 'landlord_contact_details':
                        return 'icon-phone-ring'
                    case 'comment':
                        return 'icon-comment'
                    default:
                        return 'icon-add-circle'
                }
            }
        }
    }
</script>
